import { render, staticRenderFns } from "./interestTree.vue?vue&type=template&id=dfc8de70&scoped=true"
import script from "./interestTree.vue?vue&type=script&lang=js"
export * from "./interestTree.vue?vue&type=script&lang=js"
import style0 from "./interestTree.vue?vue&type=style&index=0&id=dfc8de70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc8de70",
  null
  
)

export default component.exports